<template>
  <el-dialog title="课件更新操作日志" :visible.sync="visible" :before-close="handleClose"  width="80%">
<!--    <div style="color: red;font-weight: bold">正在使用：<span v-model="isWorking">{{isWorking}}</span></div>-->
    <el-table
      :data="tableData"

      border
      :header-cell-style="{background:'#66b1ff',color:'#fff'}"
      style="width: 100%">
      <el-table-column prop="createTime" label="时间" align="center" :formatter="renderTime"></el-table-column>
      <el-table-column prop="uname" label="操作人" align="center"></el-table-column>
      <el-table-column prop="content" label="操作内容" align="center"></el-table-column>
      <el-table-column prop="result" label="操作结果" align="center"></el-table-column>
     </el-table>
    <span slot="footer" style="width: 100%;display: inline-block;text-align: center">
      <el-button type="primary" @click="back">返 回</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as api from '@/api/courseware/checkCourseware'
import { http } from '@/utils/axios'
export default {
  name: 'CoursewareManagerAnalysis',
  data () {
    return {
      isWorking:'2',
      visible: false,
      tableData: [],
      id:'',

    }
  },
  methods: {
    // 初始化
    init (id) {
     this.visible = true
      this.id = id
      api.getListProcess(this.id).then(({data}) =>{
        console.log(data);
        data = data.data
        this.tableData = data.list
      })
    },

    // 标准时间转日期
    renderTime(date) {
      console.log(date.createTime);
      if(date.createTime == null || date.createTime == undefined || date.createTime == ''){
        return
      }else {
        var dates = new Date(date.createTime).toJSON();
        return new Date(+new Date(dates) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
      }
    },

    // 处理弹窗关闭事件
    handleClose (msg) {
      this.visible = false
      // this.$emit('close-registration-review-edit', msg)
    },

    back(){
      this.visible = false
    }


  }
}
</script>

<style lang="scss" scoped>
.content{
  @include flex(center, flex-start);
  .info{
    width: 50%;
    border-right: 1px solid  #4e5359;
    &:nth-last-child(1){
      border-right: none;
    }
    .info-title{
      @include font(18px,  #4e5359);
      text-align: center;
      padding-bottom: 20px;
    }
  }
  .el-form{
    .el-form-item{
      margin-left: 40px;
      width: 80%;
    }
  }
}
</style>
<style>

</style>
